module.exports = __webpack_public_path__ + "img/video-card.217098e8.png";